import React, { useMemo, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { buildRoute } from '../../helpers/routeHelpers';

export function GetParamsInterop({ children, param = "id" }: { children: React.ReactNode; param?: string }) {
	const [urlSearchParams] = useSearchParams();
	const { pathname } = useLocation();
	const navigate = useNavigate();
	const idGet = useMemo(() => urlSearchParams.get(param), [param, urlSearchParams]);
	useEffect(() => {
		if (idGet) {
			navigate(buildRoute(pathname, idGet));
		}
	}, [idGet, navigate, pathname]);
	return <>{children}</>;
}
